import { Box, Button, Grid, Typography } from "@mui/material";
import { Vocabulary } from "../../Utils/Vocabulary";
import LiveTvIcon from "@mui/icons-material/LiveTv";
import { isMobile } from "../../Utils/Utils";
import { useEffect, useState } from "react";
import { getData } from "../../Services/getData";
import { endpoints } from "../../Utils/UrlEnum";
import LiveCountdown from "./LiveCountDown";
import ActivateNotifications from "../ActivateNotifications";
import { AlertsTypes } from "../../Utils/Constants";

export default function LiveLegislation() {
  const [startTime, setStartTime] = useState("");
  const [liveUrl, setLiveUrl] = useState("");
  const clientId = localStorage.getItem("clientId");
  const [notificationState, setNotificationState] = useState(false);

  useEffect(() => {
    getData(endpoints.liveLegislation).then((response) => {
      if (!response.data) return;
      if (response.data?.startTime) setStartTime(response.data.startTime);
      if (response?.data?.liveVideoId)
        setLiveUrl(
          `https://www.youtube.com/watch?v=${response.data.liveVideoId}`
        );
    });

    // check if the notifications are active
    checkNotifications();
  }, []);

  const checkNotifications = async () => {
    await getData(
      `${endpoints.alert.main}/${AlertsTypes.LIVE_LEGISLATION}/${clientId}`
    ).then((response) => {
      if (response && response.data) {
        setNotificationState(response?.data);
      }
    });
  };

  const activateNotifications = () => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "end",
        }}
      >
        <ActivateNotifications
          notification={notificationState}
          setNotification={setNotificationState}
        />
      </div>
    );
  };
  return (
    <Grid
      container
      spacing={1}
      justifyContent="center"
      style={{
        padding: isMobile() ? "20px 10px" : "20px 100px",
        overflowY: "auto",
      }}
    >
      <Grid item xs={12} md={6} display="flex" alignItems="center">
        <Box textAlign="center" alignItems="center">
          {isMobile() && activateNotifications()}
          <Typography
            variant="h4"
            sx={{
              fontWeight: 700,
              mb: 2,
              color: "#1a237e",
            }}
          >
            {Vocabulary.accesLiveText}
          </Typography>
          {!startTime && liveUrl == "" && (
            <Typography
              variant="body1"
              sx={{
                mb: 4,
                fontSize: "1.1rem",
                color: "#37474f",
                lineHeight: 1.6,
                fontStyle: "italic",
              }}
            >
              {Vocabulary.noLiveScheduled}
            </Typography>
          )}
          {startTime && (
            <LiveCountdown
              messageBefore="Urmate sesiunea live de legislație incepe in:"
              startTime={startTime}
              messageAfter={Vocabulary.liveInviteText}
            />
          )}

          {liveUrl && (
            <Button
              variant="contained"
              size="large"
              startIcon={<LiveTvIcon />}
              sx={{
                fontSize: "18px",
                paddingX: 4,
                paddingY: 1.5,
                textTransform: "none",
                boxShadow: 3,
                "&:hover": {
                  backgroundColor: "#cc0000",
                  transform: "scale(1.03)",
                  transition: "all 0.2s ease-in-out",
                },
                backgroundColor: "#cc0000",
              }}
              onClick={() => {
                window.open(liveUrl, "_blank");
              }}
            >
              {Vocabulary.accessLive}
            </Button>
          )}
        </Box>
      </Grid>

      <Grid item xs={12} md={6}>
        {!isMobile() && activateNotifications()}
        <div style={{ display: "flex", alignItems: "center", height: "80%" }}>
          <Box
            component="img"
            src="/assets/images/training.png"
            alt="Live Training"
            sx={{
              width: "100%",
              maxWidth: "500px",
              display: "block",
              margin: "0 auto",
            }}
          />
        </div>
      </Grid>
    </Grid>
  );
}
